import { useState } from 'react';

import { Grid } from '@mui/material';

import { CissTextField, StatusField } from 'components/fields';
import { Filter } from 'components/filter';
import { usePermissionsContext } from 'context/PermissionsContext';
import { FilterValuesProps } from 'hooks/useFilter';

export function GrupoEconomicoListFilter() {
    const { hasPermission } = usePermissionsContext();

    const [filterTitulo, setFilterTitulo] = useState<FilterValuesProps>({
        property: 'dsGrupoEconomico',
        operator: 'like',
        value: '',
    });

    const [filterCodigo, setFilterCodigo] = useState<FilterValuesProps>({
        property: 'cdGrupoEconomico',
        operator: 'eq',
        value: '',
    });

    const [filterStatus, setFilterStatus] = useState<FilterValuesProps>({
        property: 'fgAtivo',
        operator: 'eq',
        value: hasPermission(['GRUPO_ECONOMICO_MODERAR']) ? null : true,
        idProperty: 'vlStatus',
    });

    return (
        <Filter
            filters={[
                { value: filterTitulo, setter: setFilterTitulo },
                { value: filterCodigo, setter: setFilterCodigo },
                { value: filterStatus, setter: setFilterStatus },
            ]}
        >
            <Grid sx={{ flex: 1 }}>
                <CissTextField
                    label="Título"
                    value={filterTitulo.value}
                    onChange={(e) => setFilterTitulo((oldState: FilterValuesProps) => ({ ...oldState, value: e.target.value }))}
                />
            </Grid>
            <Grid sx={{ flex: 1 }}>
                <CissTextField
                    label="Código Grupo Econômico"
                    value={filterCodigo.value}
                    onChange={(e) => setFilterCodigo((oldState: FilterValuesProps) => ({ ...oldState, value: e.target.value }))}
                />
            </Grid>
            {hasPermission(['GRUPO_ECONOMICO_MODERAR']) && (
                <Grid sx={{ flex: 1 }}>
                    <StatusField
                        value={filterStatus.value}
                        onChange={(e, value) => setFilterStatus((oldState: FilterValuesProps) => ({ ...oldState, value }))}
                    />
                </Grid>
            )}
        </Filter>
    );
}
